import type { RangeStatsDto } from "common/models/api/models/RangeStatsDto";
import { RoleType } from "common/models/role/Role";
import { UseQueryResult, useQuery } from "react-query";
import useUserState from "ui/adapter/state/useUserState";
import { Queries } from "ui/query/queries";
import type { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import useSelectedOrganization from "ui/role/hooks/useSelectedOrganization";
import { transactionsApi } from "../api/transactionsApi";

export default function useGetTransactionsStats<TData = RangeStatsDto>({
    enabled = true,
    ...options
}: UseCustomQueryOptions<RangeStatsDto, unknown, TData, (string | undefined)[]> = {}): UseQueryResult<TData> {
    const org = useSelectedOrganization();
    const tokenAddress = org?.tokenAddress;
    const { selectedRole } = useUserState();
    const safeTokenAddress = tokenAddress as string;

    return useQuery(
        [Queries.TRANSACTIONS_STATS, tokenAddress, selectedRole?.roleType],
        async () => {
            const res = await transactionsApi.getTransactionsByDay(safeTokenAddress);
            return res.data;
        },
        {
            enabled:
                enabled &&
                Boolean(tokenAddress) &&
                (selectedRole?.roleType === RoleType.ORGANIZATION_OWNER ||
                    selectedRole?.roleType === RoleType.PROGRAM_MANAGER ||
                    selectedRole?.roleType === RoleType.PARTNER ||
                    selectedRole?.roleType === RoleType.OPERATION_MANAGER ||
                    selectedRole?.roleType === RoleType.CUSTOMER_SERVICE),
            ...options,
        },
    );
}
